/* eslint-disable jsx-a11y/mouse-events-have-key-events */

// TODO: add back in if uncommenting stuff below
import { PropTypes } from 'prop-types';
import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';

import { Loader } from '@ge/components/loader';
import { SortDirection } from '@ge/components/table/models/sort-direction';
import { useColumnState } from '@ge/components/table/use-column-state';
import { useSitesTable } from '@ge/feat-monitor/data-hooks';
import { MobileTab } from '@ge/models/constants';
import { globalColors } from '@ge/tokens/colors';

import { defaultSiteCols, SitesColumnDefs } from '../../models/sites-table-cols';

export const SiteMetric = {
  NAME: 'site.name',
};

import RenderSiteList from './dynamic-list';
export const SiteLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  &.hidden {
    display: none;
  }
`;
const SiteContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-bottom: 1px solid ${globalColors.grey11};
  box-shadow: 0 2px 3px -1px rgba(0, 0, 0, 0.1);
  &.hidden {
    display: none;
  }
  &:hover {
    background-color: ${(props) => props.theme.entityDetails.siteHoverColor};
  }
  &:hover .arrow-right {
    fill: #57b5c6;
  }
  .sitesList {
    display: flex;
    gap: 4px 8px;
    padding: 8px;
    margin-left: 2px;
    h2 {
      font-size: 19px;
    }
  }
  .sitesRow {
    padding-top: 5px;
  }
  .whole-badge {
    display: flex;
    .whole-badge-wrapper {
      display: flex;
    }
  }
  .site-badge {
    border-radius: revert !important;
    margin-left: 1px;
  }
  .site-badge-first {
    border-radius: 6px 0 0 6px !important;
  }
  .site-badge-last {
    border-radius: 0 6px 6px 0 !important;
    margin-left: 1px;
  }
`;
const SORT_STATE_ID = 'monitor-sites';
const SitesMobileList = ({
  onRowSelect,
  isLoading,
  active,
  siteLoader,
  filterText,
  getFilteredSites,
}) => {
  // Table state management
  const { sortDirection, sortMetric } = useColumnState({
    columnDefs: SitesColumnDefs,
    defaultCols: defaultSiteCols,
    defaultSortMetric: SiteMetric.NAME,
    defaultSortDirection: SortDirection.ASC,
    sortStateId: SORT_STATE_ID,
  });
  const { data: sites } = useSitesTable({ sortDirection, sortMetric });
  const [allSites, setAllSites] = useState([]);

  useEffect(() => {
    setTimeout(() => setAllSites(getFilteredSites(sites)), 300);
  }, [filterText, getFilteredSites, sites]);

  const getRowDefs = useCallback(
    (value) => {
      const { conditions, assets, production, name, id } = value;
      return {
        children: (
          <RenderSiteList
            conditions={conditions}
            assets={assets}
            production={production}
            name={name}
            id={id}
          />
        ),
        key: `listing-${name}-${id}`,
        onClick: (e) => onRowSelect(e, id, MobileTab.ASSET, value),
      };
    },
    [onRowSelect],
  );
  /**
   * Build a specific row for the provided value and visible columns.
   */
  const buildRow = useCallback(
    ({ site }) => {
      // Handle both virtualized and non-virtualized scenarios. If the table is not
      // scrollable, we cannot virtualize the rows because they are all shown.
      if (!site) {
        return null;
      }
      const { children, key, onClick } = getRowDefs(site);
      return (
        <SiteContent key={key} onClick={onClick} className={!active && 'hidden'}>
          {children}
        </SiteContent>
      );
    },
    [getRowDefs, active],
  );

  if ((!allSites?.length && !isLoading) || siteLoader)
    return (
      <SiteLoader className={!active && 'hidden'}>
        <Loader />
      </SiteLoader>
    );
  return allSites.map((value, idx) => buildRow({ site: value.site, idx }));
};

SitesMobileList.propTypes = {
  onRowSelect: PropTypes.func,
  sites: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
  isLoading: PropTypes.bool,
  active: PropTypes.bool,
  siteLoader: PropTypes.bool,
  filterText: PropTypes.string,
  getFilteredSites: PropTypes.func,
};
SitesMobileList.defaultProps = {
  sites: [],
  isLoading: true,
};
export default SitesMobileList;
